import { createContext, type PropsWithChildren, useContext } from 'react'

import { type QuotingQuote } from 'utils/web_api.schemas'

type QuoteProviderProps = {
  quote: QuotingQuote | undefined
}

const QuoteContext = createContext<QuoteProviderProps>({
  quote: undefined,
})

export function useQuote () {
  return useContext(QuoteContext)
}

export function QuoteProvider ({ quote, children }: PropsWithChildren<QuoteProviderProps>) {
  return (
    <QuoteContext.Provider value={{ quote }}>
      {children}
    </QuoteContext.Provider>
  )
}
